<body>
    <div class="div-center">
        <div class="row">
            <div class="logos mb-2">
                <div class="row align-items-center">
                    <div class="col">
                        <img class="buzz-logo" src="assets/images/logo-buzz.png" alt="">
                    </div>
                    <div class="col">
                        <img class="customer-logo" [src]="imagePath" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="login-form">
                <h4>{{'LogIn'|translate}}</h4>
                <form action="">
                  <!-- alert msg -->
                  <ng-container *ngIf="loginErrorMsgName">
                    <div class="alert alert-danger mb-3" role="alert">
                      <i class="fa-solid fa-ban error"></i>
                      {{loginErrorMsgName | translate}}
                    </div>
                  </ng-container>

                  <div class="form-group mb-3">
                    <label for="Input1" class="form-label">{{'Authentication'|translate}}</label>
                    <select id="Input1" class="form-select" aria-label="Authentication"
                            (change)="selectionAuthTypeChange($event.target.value)">
                      <option *ngFor="let unit of AuthTypeItems; index as i" [value]="i"
                              [selected]="unit.value == defaultAuth.value">{{ unit.text }}</option>
                    </select>
                  </div>

                  <div class="form-group mb-3">
                    <label for="Input2"
                           [ngClass]="UserNameErrorMSg != '' ? 'form-label error' : 'form-label'">{{'UserName'|translate}}</label>
                    <input type="text" [value]="username" [(ngModel)]="creds.Username" #username="ngModel"
                           name="username" (blur)="onLoseFocusUsername()"
                           [ngClass]="UserNameErrorMSg != '' ? 'form-control error' : 'form-control'" id="username">
                    <ng-container *ngIf="UserNameErrorMSg">
                        <span *ngIf="UserNameErrorMSg" class="info-icon">
                            <mat-icon [matTooltip]="UserNameErrorMSg | translate">error_outline</mat-icon>
                        </span>
                    </ng-container>
                  </div>

                  <div class="form-group mb-3">
                    <label for="password"
                           [ngClass]="passwordErrorMSg != '' ? 'form-label error' : 'form-label'">{{"Password" |
                            translate}}</label>
                    <input [type]="showPassword ? 'text' : 'password'"
                           [ngClass]="passwordErrorMSg != '' ? 'form-control error' : 'form-control'" name="password"
                           [(ngModel)]="Displayedpassword" #password="ngModel" (blur)="onLoseFocusPassword()"
                           autocomplete="current-password" required="" id="password">
                           <div (click)="showPassword = !showPassword">
                            <span *ngIf="showPassword" class="eye-icon">
                                <i class='fa-regular fa-eye-slash'
                                ></i>
                            </span>
                            <span *ngIf="!showPassword" class="eye-icon">
                                <i class='fa-regular fa-eye'></i>
                            </span>
                        </div>
                    <ng-container *ngIf="passwordErrorMSg">
                        <span *ngIf="passwordErrorMSg" class="info-next-eye">
                            <mat-icon [matTooltip]="passwordErrorMSg | translate">error_outline</mat-icon>
                        </span>
                    </ng-container>
                  </div>

                  <app-language-select (UpdateCredsLanguage)="UpdateCredsLanguage($event)"></app-language-select>

                  <button (click)="onLoginClick()" class="btn m-0">{{'LogIn'|translate}}</button>
                </form>
            </div>
        </div>
    </div>
</body>
